module.exports = __webpack_public_path__ + "img/apply-up.1712f5b8.svg";